import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import MainSpeakers from "./components/MainSpeakers";
import GuestSpeakers from "./components/GuestSpeakers";
import StudentAchievements from "./components/StudentAchievements";
import PartnersSection from "./components/PartnersSection";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <LanguageProvider>
      <div className="min-h-screen w-full font-sans bg-white">
        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <MainSpeakers />
          <GuestSpeakers />
          <StudentAchievements />
          <PartnersSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}
